import { Reveal } from "./Reveal";
import { PenLine, Camera, Flame } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: PenLine,
    title: "Declare It",
    body: "Set your goal for the day and put it on the record. The second you declare it, the clock starts and your streak is on the line.",
  },
  {
    n: "02",
    icon: Camera,
    title: "Prove It",
    body: "Do the thing, then back it up \u2014 snap a photo or drop a screenshot. No proof, no credit. Receipts only.",
  },
  {
    n: "03",
    icon: Flame,
    title: "Own It",
    body: "Watch your streak climb and your ledger fill. Pull your circle in \u2014 nothing keeps you honest like people who are watching.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how" className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-36">
      <div className="mb-14 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <Reveal>
          <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#C9A94B]">
            [ How it works ]
          </span>
          <h2 className="mt-4 font-display text-5xl uppercase leading-[0.9] tracking-tight text-white md:text-7xl">
            Three steps.<br />Zero excuses.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="max-w-xs font-body text-sm leading-relaxed text-[#8A8A8A]">
            proof turns intentions into a permanent record. Say it, prove it, repeat.
          </p>
        </Reveal>
      </div>

      <div className="border-t border-[#1F1F1F]">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.n} delay={i * 0.08}>
              <div className="group grid grid-cols-1 items-start gap-6 border-b border-[#1F1F1F] py-10 transition-colors hover:bg-white/[0.015] md:grid-cols-[160px_1fr_auto] md:gap-10 md:py-14">
                <span className="font-display text-6xl leading-none text-[#242424] transition-colors duration-300 group-hover:text-[#C9A94B] md:text-8xl">
                  {s.n}
                </span>
                <div className="max-w-xl">
                  <h3 className="font-display text-3xl uppercase tracking-tight text-white md:text-4xl">
                    {s.title}
                  </h3>
                  <p className="mt-3 font-body text-base leading-relaxed text-[#A1A1AA]">
                    {s.body}
                  </p>
                </div>
                <span className="flex h-12 w-12 items-center justify-center border border-[#1F1F1F] text-[#8A8A8A] transition-colors duration-300 group-hover:border-[#C9A94B] group-hover:text-[#C9A94B]">
                  <Icon className="h-5 w-5" strokeWidth={1.6} />
                </span>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
